import { AuthorizeAction, GET_FCM_TOKEN } from "store/constants"

export const doLogin = () => (dispatch) => {
  return dispatch({ 
    type: AuthorizeAction.LOGIN_ACTION
  })
}

export const doLogout = () => (dispatch) => {
  return dispatch({ 
    type: AuthorizeAction.LOGOUT_ACTION
  })
}

export const doLogin3G = () => (dispatch) => {
  return dispatch({ 
    type: AuthorizeAction.LOGIN_3G_4G
  })
}

export const doFCMToken = (data) => (dispatch) => {
  return dispatch({ 
    type: GET_FCM_TOKEN,
    payload: data
  })
}
